/* ALCAMI REVIEWS
   Safety net for the review order. Judge.me pre-renders the first page of product reviews and
   can serve a page saved before the default sort changed, so a fresh low rating can show first
   even with "Highest Rating" selected. When the default sort is Highest Rating and the first page
   is not in rating order, this hides that list, asks Judge.me for the first page again with the
   right sort as the widget nears the screen, and shows it once the sorted reviews are in.
   A correctly sorted page is left alone (no extra request). Loaded from layout/theme.liquid. */
(function(){
  if (window.__alcReviews) return;
  window.__alcReviews = true;

  var FALLBACK = 'highest-rating';
  var GIVE_UP = 20000;   /* stop waiting for Judge.me after 20 s */
  var REVEAL = 6000;     /* never keep the list hidden longer than this after asking */

  var wanted = function(){ return (window.jdgmSettings && window.jdgmSettings.default_sort_method) || FALLBACK; };
  var sortSelect = function(w){
    /* the write-review form also has a .jdgm-sort-dropdown (name format), so pick the one with the sort options */
    var all = w.querySelectorAll('.jdgm-rev-widg__sort-wrapper select, select.jdgm-sort-dropdown');
    for (var i = 0; i < all.length; i++) {
      if ([].some.call(all[i].options, function(o){ return o.value === 'most-recent'; })) return all[i];
    }
    return null;
  };
  var outOfOrder = function(w){
    var sc = [].map.call(w.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev__rating'), function(r){ return parseFloat(r.getAttribute('data-score')) || 0; });
    for (var i = 1; i < sc.length; i++) { if (sc[i] > sc[i - 1]) return true; }
    return false;
  };
  var reveal = function(w){ w.classList.remove('alc-rv-sorting'); };

  var resort = function(w){
    if (w.__alcRvDone) return;
    var sel = sortSelect(w);
    var list = w.querySelector('.jdgm-rev-widg__reviews');
    var $ = window.jdgm && window.jdgm.$;
    if (!sel || !list || !$ || !w.classList.contains('jdgm--done-setup-widget')) return;
    w.__alcRvDone = true;
    var sort = wanted();
    if (!list.querySelector('.jdgm-rev') || ![].some.call(sel.options, function(o){ return o.value === sort; })) { reveal(w); return; }
    var oldFirst = list.querySelector('.jdgm-rev');
    var timer = setTimeout(function(){ mo.disconnect(); reveal(w); }, REVEAL);
    var settle = 0;
    var mo = new MutationObserver(function(){
      /* wait until the old first review has been replaced by the sorted page */
      if (w.querySelector('.jdgm-rev-widg__reviews .jdgm-rev') === oldFirst) return;
      clearTimeout(settle);
      settle = setTimeout(function(){ mo.disconnect(); clearTimeout(timer); reveal(w); }, 200);
    });
    mo.observe(w, { childList: true, subtree: true });   /* Judge.me swaps the whole list, so watch the widget */
    $(sel).val(sort).trigger('change');
  };

  var watch = function(w){
    if (w.__alcRvWatch) return;
    if (!w.querySelector('.jdgm-rev-widg__reviews .jdgm-rev')) return;   /* not rendered yet, try again on the next scan */
    w.__alcRvWatch = true;
    if (wanted() !== 'highest-rating' || !outOfOrder(w)) return;
    w.classList.add('alc-rv-sorting');
    var go = function(){
      var t0 = Date.now();
      var tick = function(){
        if (w.__alcRvDone) return;
        if (Date.now() - t0 > GIVE_UP) { w.__alcRvDone = true; reveal(w); return; }
        resort(w);
        if (!w.__alcRvDone) setTimeout(tick, 250);
      };
      tick();
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        if (es.some(function(e){ return e.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '1200px 0px' });
      io.observe(w);
    } else { go(); }
  };

  var scan = function(){
    [].forEach.call(document.querySelectorAll('.jdgm-widget.jdgm-review-widget'), watch);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  /* widgets that Judge.me or a section adds later */
  var rescans = 0;
  var again = setInterval(function(){ scan(); if (++rescans > 20) clearInterval(again); }, 1000);
})();
